import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Fingerprint, LogIn, LogOut, CheckCircle, AlertCircle } from 'lucide-react';

const StaffAttendance = () => {
  const { empId } = useParams();
  const navigate = useNavigate();
  const [empData, setEmpData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchStatus = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
    //   const res = await axios.get(`http://localhost:5551/employees?date=${today}`);
      // const res = await axios.get(`https://attendance.nadezhda.in:5551/employees?date=${today}`);
      const res = await axios.get(`/api/employees?date=${today}`);
      const myData = res.data.find((e: any) => e.id === Number(empId));
      if (myData) {
        setEmpData(myData);
        setError(false);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  };

  useEffect(() => {
    if (empId) fetchStatus();
  }, [empId]);

  const handlePunch = async (type: 'in' | 'out') => {
    setLoading(true);
    const now = new Date().toLocaleTimeString('en-GB', { hour12: false });

    // Fingerprint Bypass for localhost testing
    try {
      if (window.isSecureContext && navigator.credentials) {
        await navigator.credentials.get({ publicKey: { challenge: new Uint8Array(32), userVerification: 'required' } });
      }
    } catch (e) { console.log("Biometric Bypassed"); }

    try {
      // await axios.post('https://attendance.nadezhda.in:5551/attendance/update', {
      await axios.post('/api/attendance/update', {
      // await axios.post('http://192.168.1.11:5000/attendance/update', {
        employee_id: empId,
        [type === 'in' ? 'in_time' : 'out_time']: now
      });
      fetchStatus();
    } catch (err) { alert("Server Error!"); }
    setLoading(false);
  };

  if (error) return (
    <div className="text-center mt-20">
      <AlertCircle size={48} className="mx-auto text-red-500 mb-4" />
      <h2 className="text-xl font-bold">Invalid Staff Link</h2>
      <button onClick={() => navigate('/login')} className="mt-4 text-blue-600 font-bold">Go to Login</button>
    </div>
  );

  if (!empData) return <div className="text-center mt-20 font-bold animate-pulse text-slate-400">LOADING PORTAL...</div>;

  const isDone = empData.in_time && empData.out_time;

  return (
    <div className="max-w-md mx-auto mt-10 p-8 bg-white rounded-[40px] shadow-2xl border border-slate-100 text-center">
      <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
        <Fingerprint size={48} className={loading ? "text-blue-300 animate-pulse" : "text-blue-600"} />
      </div>

      <h1 className="text-2xl font-black text-slate-800">Hi, {empData.name}</h1>
      <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-8">{empData.designation}</p>

      {isDone ? (
        <div className="bg-slate-50 p-8 rounded-3xl border-2 border-dashed border-slate-200">
          <CheckCircle className="mx-auto text-emerald-500 mb-3" size={48} />
          <p className="font-black text-slate-700">SESSION OVER</p>
          <p className="text-xs text-slate-400 mt-1">Attendance complete for today. Goodbye!</p>
        </div>
      ) : (
        <div className="space-y-4">
          {!empData.in_time ? (
            <button onClick={() => handlePunch('in')} disabled={loading} className="w-full bg-emerald-600 text-white py-5 rounded-2xl font-black flex items-center justify-center gap-3 shadow-lg shadow-emerald-100 transition-transform active:scale-95">
              <LogIn /> PUNCH IN NOW
            </button>
          ) : (
            <div className="space-y-4">
              <div className="p-4 bg-emerald-50 text-emerald-700 rounded-2xl font-black text-xs border border-emerald-100">
                PUNCHED IN AT {empData.in_time}
              </div>
              <button onClick={() => handlePunch('out')} disabled={loading} className="w-full bg-red-600 text-white py-5 rounded-2xl font-black flex items-center justify-center gap-3 shadow-lg shadow-red-100 transition-transform active:scale-95">
                <LogOut /> PUNCH OUT NOW
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default StaffAttendance;